<div class="notification-body">
  <p>{{ 'TGA.Notifications.SupplementaryFertilizerAdvised.Description' | translate }}</p>
</div>
